// extracted by mini-css-extract-plugin
module.exports = {"product":"_1K0QDI","button":"_1fyA5G","image":"_2CNg1J"};